import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import * as MasterConstants from 'app/pages/masterconstants'; 
import { Http } from '@angular/http';
import { Headers, Response, URLSearchParams } from '@angular/http';
// import {} from ''
// const store = require('store');

const MINUTES_UNITL_AUTO_LOGOUT = 60 // in mins
const CHECK_INTERVAL = 15000 // in ms
const STORE_KEY =  'lastAction';
@Injectable()
export class AutoLoginService {

  constructor(private router: Router,private http: Http) {

  }

  getLogin(accessKey) {
    var headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('key',accessKey);
    let body = urlSearchParams.toString(); 
    return this.http.post(MasterConstants.WEB_URL + 'loginAutoUser.php', body, {
        headers: headers
    }).map(res => res.json());  

  }

}


// WEBPACK FOOTER //
// ./src/app/autoLogin/autoLoginService.ts